const WeeklyForecast = ({weeklyWeather, weekDays, handleClick}) => {
  return ( 
    <div>
      <div className="pt-3 px-4 m-2 mt-8">
        <h1 className="text-center text-3xl md:text-left">
          Weekly Forecast
        </h1>
      </div>
      <div className="flex flex-row m-1 mb-8 mx-6 overflow-auto">
        { weeklyWeather.days.slice(0,7).map((day, index) =>  <div className="p-2 m-2 mt-0 flex-auto justify-center text-center" key={index}>
          <div onClick={() => handleClick(index) } className='cursor-pointer'>
            <p>{weekDays[new Date(day.datetime).getDay()]}</p>
            <img className='m-2' alt='hail' src={require('./../icons/' + day.icon + ".png")} style={{marginLeft: "auto", marginRight: "auto"}} width="40px" height="40px"/>
            {day.temp} °c
          </div>
        </div> )}
      </div>
    </div>
   );
}
 
export default WeeklyForecast;